"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NominalTable = _react2["default"].createClass({
	displayName: "NominalTable",
	render: function render() {
		return _react2["default"].createElement(
			"div",
			{ className: "nominal-table" },
			this.props.children
		);
	}
});

exports["default"] = NominalTable;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./components/business/nominalTable.jsx
 ** module id = 627
 ** module chunks = 0
 **/